import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { materialDark } from "react-syntax-highlighter/dist/esm/styles/prism";

export const CodeViewer = ({ code, language }) => {
    return (
        <SyntaxHighlighter language={language} style={materialDark}>
            {code}
        </SyntaxHighlighter>
    );
}

export default CodeViewer;